var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "article",
    { staticClass: "bic-list__bic-item bic-item bic-item--alternate" },
    [
      _c("button", {
        staticClass: "bic-item__alt-close",
        on: { click: _vm.clearAlternateBic },
      }),
      _vm._v(" "),
      _c("h3", { staticClass: "bic-item__title" }, [
        _vm._v(_vm._s(_vm.item.desc)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bic-item__subtitle" }, [
        _c("div", { staticClass: "bic-item__code-label" }, [
          _vm._v("Business Industry Code:"),
          _c("span", { staticClass: "bic-item__code" }, [
            _vm._v(" " + _vm._s(_vm.item.code)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bic-item__details" }, [
        _vm.item.important
          ? _c("div", { staticClass: "important" }, [
              _vm._v(_vm._s(_vm.item.important)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.item.definition
          ? _c("div", {
              staticClass: "definition",
              domProps: { innerHTML: _vm._s(_vm.item.definition) },
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.item.definition
          ? _c("div", { staticClass: "noDefinition" }, [
              _vm._v(
                "Click 'More' to see Classification Unit and ANZSIC codes."
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.item.historyYear
          ? _c("div", { staticClass: "bic-item__section" }, [
              _c("b", [_vm._v("Valid from:")]),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "bic-item__section-content" }, [
                _vm._v(
                  "This code is only valid for registrations after 1 April " +
                    _vm._s(_vm.item.historyYear) +
                    " and tax returns for " +
                    _vm._s(_vm.item.historyYear) +
                    " onwards."
                ),
              ]),
              _vm._v(" "),
              _vm.item.historyBicId
                ? _c("div", { staticClass: "bic-item__section-content" }, [
                    _vm._v(
                      "For earlier years use " +
                        _vm._s(_vm.item.historyBic.code) +
                        " " +
                        _vm._s(_vm.item.historyBic.desc)
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "bic-item__section" }, [
          _c("div", { staticClass: "bic-item__section-header" }, [
            _vm._v("Classification Unit (CU): " + _vm._s(_vm.item.cu.code)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bic-item__section-header" }, [
            _vm._v(_vm._s(_vm.item.cu.desc)),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bic-item__section" }, [
          _c("div", { staticClass: "bic-item__section-header" }, [
            _vm._v("ANZSIC: " + _vm._s(_vm.item.anzsic.code)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bic-item__section-header" }, [
            _vm._v(_vm._s(_vm.item.anzsic.desc)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bic-item__section-content" }, [
            _vm._v(
              "Statistics NZ uses this to compile and analyse industry statistics."
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "bic-item__section-content" }, [
      _vm._v("This is used by ACC to calculate your levies. "),
      _c(
        "a",
        {
          staticClass: "external",
          attrs: {
            id: "",
            target: "_blank",
            href: "https://www.acc.co.nz/Calculator",
          },
        },
        [_vm._v("Calculate your levies")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }